import { z } from 'zod'

import { userPath, usersPath } from './paths'

/** Where Find Sign-Ins lives. */
export const signInsPath = '/site-management/sign-ins'

/** Where a user's Sign In History lives. */
export const userSignInsRoute = `${usersPath}/:publicId/sign-ins`

/** A user's Sign In History. */
export function userSignInsPath(id: string): string {
  return `${userPath(id)}/sign-ins`
}

/** The API's sign-in search, and its export at `${signInsApi}/export`. */
export const signInsApi = '/site-management/v1/sign-ins'

/** The API's sign-ins of one user, and their export at `/export` after it. */
export function userSignInsApi(id: string): string {
  return `/site-management/v1/users/${encodeURIComponent(id)}/sign-ins`
}

const signInSchema = z.object({
  id: z.string(),
  signedInOn: z.string(),
  userId: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  displayName: z.string(),
  email: z.string().nullish(),
  externalId: z.string().nullish(),
  organizationId: z.string().nullish(),
  organizationName: z.string(),
  method: z.string(),
  identityProvider: z.string().nullish(),
  ipAddress: z.string().nullish(),
})

/** A sign-in on the site, as Find Sign-Ins and Sign In History list it. */
export type SignIn = z.infer<typeof signInSchema>

export function parseSignIn(item: unknown): SignIn {
  return signInSchema.parse(item)
}
